<template>
  <div style="padding: 15px">
    <el-form ref="form" :model="form" :rules="rules" label-width="200px" label-position="left">
      <el-form-item label="您当前最多可申请提现金额">
        <el-input v-model="form.maxAmount" placeholder="您当前最多可申请提现金额" disabled>
          <template slot="append">
            元
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="totalAmount" label="请输入本次申请提现金额">
        <el-input v-model="form.totalAmount" placeholder="请输入金额" @input="(value)=>formFormatter.isFloor2(value,oldValue,form,'totalAmount')">
          <template slot="append">
            元
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="银行卡号"><el-input v-model="form.bankCardNo" placeholder="银行卡号" disabled /></el-form-item>
      <el-form-item prop="smsCode" label="验证码">
        <el-row style="display: flex;align-items: center; ">
          <el-col :span="18">
            <div class="grid-content bg-purple"><el-input v-model="form.smsCode" class="elInput" :placeholder="$t('register.phonecode')" type="text" /></div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple-light" style="display: inline-block; text-align: right;">
              <el-button v-show="show" type="primary" round size="mini" @click="getCode">获取验证码</el-button>
              <el-button v-show="!show" type="primary">{{ count }} s</el-button>
              <!-- <span v-show="!show" class="count">{{ count }} s</span> -->
            </div>
          </el-col>
        </el-row>
      </el-form-item>
      <el-button type="primary" :disabled="disabled" @click="addClick('form')">确定</el-button>
    </el-form>
  </div>
</template>
<script>
import {sendWithdrawCode, withdrawPlatform } from '@/api/InternetBanking';
export default {
	name: 'MerchantManagementAdd',
	data() {
		var validatePass = (rule, value, callback) => {
			let  reg = /^([1-9]\d*|0)(\.\d{1,2})?$/;
			if (!reg.test(value)) {
				callback(new Error('请输入提现金额'));
			} else if (value > this.form.maxAmount) {
				callback(new Error('输入金额大于可申请提现金额'));
			} else {
				callback();
			}
		};
		return {
			vardel: false,
			distrue: false,
			provinceList: [],
			cityList: [],
			districtList: [],
			show: true,
			count: '',
			form: {
				totalAmount: '',
				smsCode: ''
			},
			rules: {
				totalAmount: [{ required: true, validator: validatePass, trigger: 'blur' },
				],
				smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
			},
			datas: {},
			disabled: false,
		};
	},
	created() {},
	methods: {
		getCode() {
			if(!this.form.totalAmount){
				this.$message.error("请输入提现金额");
				return false;
			}
			sendWithdrawCode( {phone:  this.form.phone}).then(response => {
			  if (response.status == 0) {
			    const TIME_COUNT = 60;
			    if (!this.timer) {
			      this.count = TIME_COUNT;
			      this.show = false;
			      this.timer = setInterval(() => {
			        if (this.count > 0 && this.count <= TIME_COUNT) {
			          this.count--;
			        } else {
			          this.show = true;
			          clearInterval(this.timer);
			          this.timer = null;
			        }
			      }, 1000);
			    }
			  }
			});
		},
		init(datas) {
			this.$refs.form.resetFields();
			this.form = datas;
		},
		close() {
			this.$refs.form.resetFields();
		},
		//提交
		addClick(form) {
			this.$refs[form].validate(valid => {
				if (valid) {
					this.disabled = true
					const rLoading = this.openLoading();
					let data = this.form
					withdrawPlatform(data).then(response => {
						rLoading.close();
						this.$message({ message: response.msg, type: 'success' });
						this.$emit('confirm');
						this.disabled = false
						this.$refs.form.resetFields();
					}).catch( err => {
						this.disabled = false;
						rLoading.close();
					})
				} else {
					return false;
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.titleh1 {
	line-height: 50px;
	border-bottom: 1px solid #e2e2e2;
	margin-bottom: 15px;
	code {
		width: 5px;
		height: 20px;
		background-color: #ff7f21;
		float: left;
		margin-right: 5px;
		margin-top: 13px;
	}
}
.bg-purple-light {
	span {
		color: #fff;
		line-height: 50px;
		font-size: 13px;
		text-align: right;
		display: block;
	}
}
</style>
